import './marketbasket/style';
import FormStructure from './marketbasket/form_structure';

export default FormStructure;